import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { RegApi } from "../api/services";
import { errorMessage } from "../api/client";
import { Field, PasswordInput } from "../components/common";
import { AuthLayout, ERR_CLS } from "./AuthPages";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [step, setStep] = useState<1 | 2>(1);
  const [username, setUsername] = useState("");
  const [otp, setOtp] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async (e: FormEvent, fn: () => Promise<void>) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await fn(); } catch (ex) { setErr(errorMessage(ex)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title="Forgot password" subtitle={step === 1 ? "We'll email a 6-digit reset code to the address on your account." : "Enter the code from your email and choose a new password."}>
      {step === 1 ? (
        <form className="space-y-4" onSubmit={(e) => run(e, async () => { await RegApi.forgot(username); setStep(2); })} data-testid="forgot-form">
          <Field label="Username"><input className="fp-input" autoCapitalize="none" required value={username} onChange={(e) => setUsername(e.target.value)} data-testid="forgot-username-input" /></Field>
          {err && <p role="alert" className={ERR_CLS}>{err}</p>}
          <button className="fp-btn h-12 w-full bg-[#003F32] text-white" disabled={busy} data-testid="forgot-send-button">Send reset code</button>
        </form>
      ) : (
        <form className="space-y-4" onSubmit={(e) => run(e, async () => { await RegApi.reset(username, otp, pw); toast.success("Password updated. Please sign in."); nav("/"); })} data-testid="reset-form">
          <Field label="6-digit code"><input className="fp-input font-mono tracking-[0.4em]" inputMode="numeric" maxLength={6} required value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))} data-testid="reset-otp-input" /></Field>
          <Field label="New password" hint="At least 8 characters"><PasswordInput minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" /></Field>
          {err && <p role="alert" className={ERR_CLS} data-testid="reset-error">{err}</p>}
          <button className="fp-btn h-12 w-full bg-[#003F32] text-white" disabled={busy} data-testid="reset-submit-button">Update password</button>
        </form>
      )}
      <p className="mt-5 text-sm"><Link to="/" className="font-semibold text-[#036248] underline">Back to sign in</Link></p>
    </AuthLayout>
  );
}
